import { createAsyncThunk } from '@reduxjs/toolkit';
import { Enums, Paths, Value } from '@utils/constants';
import { addLoading, removeLoading } from '../appAction';
import { axios } from '@utils/lib';

export const getSsidListAsync = createAsyncThunk(
  'api/getSsidListAsync',
  async (
    { query, hideLoading }: IGetSsidApi,
    { rejectWithValue, dispatch },
  ) => {
    const searchQuery: Record<string, string> = {
      'pagination[page]': query.page ?? Value.TABLE_PAGE_INIT,
      'pagination[pageSize]': query.pageSize ?? Value.TABLE_PAGE_SIZE,
      sort: 'id:desc',
    };
    if (query.name) searchQuery['filters[name][$contains]'] = query.name;

    const params = new URLSearchParams(searchQuery).toString();
    if (!hideLoading) {
      dispatch(addLoading());
    }
    try {
      const { data } = await axios.request<IListRes<ISsidData>>(
        Enums.HTTP_METHOD.GET,
        Paths.SSIDS + '?' + params,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
